module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-r-w.a1ef7f9e.svg";